var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Java(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "96px",
    height: "96px",
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Wea)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Wea",
    x1: 31.287,
    x2: 31.287,
    y1: 3.383,
    y2: 62.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Wea)",
    d: "M23.749,48.868c-9.61,2.669,5.846,8.183,18.081,2.971c-2.004-0.775-3.439-1.669-3.439-1.669 c-5.458,1.027-7.99,1.107-12.942,0.546C21.36,50.249,23.749,48.868,23.749,48.868z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Web",
    x1: 30.914,
    x2: 30.914,
    y1: 3.911,
    y2: 62.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Web)",
    d: "M40.365,43.613c-7.23,1.364-11.408,1.32-16.699,0.785c-4.091-0.415-1.412-2.357-1.412-2.357 c-10.587,3.442,5.89,7.346,20.684,3.108C41.365,44.606,40.365,43.613,40.365,43.613z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Wec",
    x1: 39.018,
    x2: 39.018,
    y1: 3.213,
    y2: 62.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Wec)",
    d: "M46.036,13.383c0,0-21.54,5.331-11.252,17.079c3.035,3.463-0.797,6.579-0.797,6.579 s7.706-3.942,4.167-8.879C34.848,23.557,32.313,21.27,46.036,13.383z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Wed",
    x1: 30.574,
    x2: 30.574,
    y1: 3.373,
    y2: 62.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Wed)",
    d: "M51.041,53.916c0,0,1.768,1.448-1.947,2.569c-7.063,2.128-29.395,2.77-35.599,0.085 c-2.23-0.965,1.952-2.304,3.268-2.585c1.372-0.296,2.156-0.241,2.156-0.241c-2.48-1.737-16.031,3.412-6.883,4.886 C36.983,62.653,57.512,56.818,51.041,53.916z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Wee",
    x1: 29.622,
    x2: 29.622,
    y1: 3.213,
    y2: 62.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Wee)",
    d: "M42.465,38.765c1.199-0.817,2.857-1.525,2.857-1.525s-4.721,0.841-9.422,1.237 c-5.753,0.481-11.928,0.574-15.026,0.161c-7.337-0.977,4.023-3.669,4.023-3.669s-4.411-0.297-9.837,2.32 C8.645,40.384,30.93,41.792,42.465,38.765z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Wef",
    x1: 50.02,
    x2: 50.02,
    y1: 0.999,
    y2: 64.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Wef)",
    d: "M45.276,46.675C45.222,46.829,45.04,47,45.04,47c15.704-4.351,9.93-15.336,2.423-12.555 c-0.659,0.247-1.005,0.817-1.005,0.817s0.415-0.177,1.345-0.381C51.598,34.048,57.034,40.236,45.276,46.675z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Weg",
    x1: 32,
    x2: 32,
    y1: 3.213,
    y2: 62.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Weg)",
    d: "M32.225,34.854c-2.293-5.208-10.071-9.766,0.004-17.76 c12.564-9.966,6.116-16.447,6.116-16.447c2.602,10.295-9.172,13.403-13.422,19.815C22.029,24.83,26.344,29.523,32.225,34.854z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NYqtCkFrnKYpo6Y7I~_Weh",
    x1: 36.106,
    x2: 36.106,
    y1: 3.212,
    y2: 62.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NYqtCkFrnKYpo6Y7I~_Weh)",
    d: "M45.697,60.706c-9.607,1.804-21.456,1.593-28.484,0.437c0,0,1.439,1.188,8.837,1.661 c11.256,0.719,28.541-0.399,28.95-5.712C55,57.092,54.213,59.106,45.697,60.706z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Java);
export default __webpack_public_path__ + "static/media/icons8-java.212df3bd24be654aa6b2227e301db78e.svg";
export { ForwardRef as ReactComponent };